// extracted by mini-css-extract-plugin
export default {"vehicleFormWidget":"VehicleFormWidget_vehicleFormWidget__OO2UY","buttonts":"VehicleFormWidget_buttonts__CMRS+"};